import {isNotNilOrEmpty} from 'ramda-adjunct';

import {PurchaseVehicleType} from '@dms/api/finance';
import {BusinessCaseResponseBody} from '@dms/api/sales';
import {SaleVehicleResponseBody} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

/**
 * The single definition of what makes a vehicle brokerage - the sale vehicle itself says so, the
 * business case is a purchase brokerage, or it is linked to a brokerage business case.
 *
 * Both entities are passed whole so that no caller has to decide what a brokerage business case is.
 * Note that an unresolved sale vehicle yields IN_STOCK, so a caller that renders before the request
 * settles has to withhold the trade type until it does.
 */
export const getVehicleTradeType = (
  saleVehicle: Pick<SaleVehicleResponseBody, 'type'> | Nullish,
  businessCase:
    | Pick<BusinessCaseResponseBody, 'businessCaseInternalType' | 'brokerageBusinessCaseId'>
    | Nullish
): PurchaseVehicleType =>
  saleVehicle?.type === 'BROKERAGE' ||
  businessCase?.businessCaseInternalType === 'PURCHASE_BROKERAGE' ||
  isNotNilOrEmpty(businessCase?.brokerageBusinessCaseId)
    ? 'BROKERAGE'
    : 'IN_STOCK';
